export enum Styles {
  SUCCESS = 'success-400-text icon-complete-circle',
  PARTIALSUCCESS = 'warning-200-text  icon-amfam-alert-triangle-fill-1',
  FAILURE = 'error-600-text icon-alert'
}
